<template>
  <v-container class="
      text-caption
      text-sm-subtitle-1
      text-md-subtitle-1
      text-lg-subtitle-1
      text-xl-subtitle-1
    ">
    <v-form ref="form">
      <v-row>
        <v-col cols="12" xl="6" lg="6" md="6">
          <v-row v-if="isVersions">
            <v-col class="pb-0 mt-3">
              <v-combobox outlined label="Selecciona versión" background-color="white" v-model="version"
                :items="versions" >
              </v-combobox>
            </v-col>
          </v-row>
          <v-row class="">
            <v-col class="pb-2">
              <span class="primary--text font-weight-bold">Nombre del proyecto</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-0">
              <v-text-field solo label="Nombre" outlined :disabled="isEnabledName" :rules="validation('nombre')"
                v-model="form.name" background-color="white"></v-text-field>
            </v-col>
          </v-row>
          <v-row class="">
            <v-col class="pb-2">
              <span class="primary--text font-weight-bold">Cultivo</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-0" cols="12">
              <v-autocomplete solo label="Seleccionar nombre del cultivo" outlined
                v-model="cropSelected" :items="crop_items" background-color="white" ref="crop_input"></v-autocomplete>
            </v-col>
            <v-col v-for="(crop, index) of form.crops" :key="index">
              <v-chip close @click:close="removeCrop(index)">
                {{ getCrop(crop) }}
              </v-chip>
            </v-col>
          </v-row>
          <v-row class="mt-0">
            <v-col class="pb-2">
              <span class="primary--text font-weight-bold">Objetivo del proyecto</span>
            </v-col>
          </v-row>
          <v-row v-if="showGenericTarget">
            <v-col class="py-0">
              <v-textarea solo label="Objetivo" outlined :rules="validation('objetivo')" v-model="form.target"
                background-color="white"></v-textarea>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col class="py-0">
              <v-combobox solo label="Objetivo" outlined :rules="validationTargets" v-model="currentTarget"
                :disabled="form.crops.length == 0" ref="targets" :items="form.crops.includes('avocado') ||
                  form.crops.includes('raspberry') ||
                  form.crops.includes('strawberry') ||
                  form.crops.includes('blackberry') ||
                  form.crops.includes('blueberry')
                  ? targets_avocado
                  : targets
                  " background-color="white" return-object></v-combobox>
            </v-col>
          </v-row>
          <v-row>
            <v-col v-for="(target, index) of form.targets" :key="index">
              <v-chip close @click:close="removeTarget(index)">
                {{ target.text }}
              </v-chip>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" xl="6" lg="6" md="6" :class="this.$vuetify.breakpoint.name != 'xl' &&
          this.$vuetify.breakpoint.name != 'lg' &&
          this.$vuetify.breakpoint.name != 'md'
          ? 'mt-0 pt-0'
          : ''
          ">
          <v-row class="mt-0">
            <v-col class="pb-2">
              <span class="primary--text font-weight-bold">Notas</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-0">
              <v-textarea solo label="Notas" outlined v-model="form.notes" background-color="white"></v-textarea>
            </v-col>
          </v-row>
          <v-row class="">
            <v-col class="pb-2">
              <span class="primary--text font-weight-bold">Duración estimada del programa</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-0">
              <v-autocomplete solo label="Meses" outlined :rules="validationF('duración')" v-model="form.cycleLength"
                :items="months" background-color="white"></v-autocomplete>
            </v-col>
          </v-row>
            <v-row class="">
            <v-col class="pb-2">
              <span class="primary--text font-weight-bold">Solubilización fósforo y postasio</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-0">
              <v-card class="rounded-xl">
                <v-card-text>
                   <v-radio-group v-model="form.solubilization" row>
                    <v-row>
                      <v-col class="d-flex justify-center">
                        <v-radio class="grayColor" color="orange darken-1" label="Si"
                          :value="true"></v-radio>
                      </v-col>
                        <v-col class="d-flex justify-center">
                        <v-radio class="grayColor" color="orange darken-1" label="No"
                          :value="false"></v-radio>
                      </v-col>
                    </v-row>
                  </v-radio-group>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row class="">
            <v-col class="pb-2">
              <span class="primary--text font-weight-bold">Zona(s) de muestreo</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-0">
              <v-combobox solo label="Seleccione zona(s) de muetreo" outlined v-model="currentSoil"
                :search-input.sync="search" @keydown="changeIdentificationValue" @change="cleanError" item-text="name"
                clearable :error="errorAreas" :error-messages="messageError" ref="units" hide-no-data :items="soilAreas"
                :loading="isLoading" background-color="white" ></v-combobox>
            </v-col>
          </v-row>
          <v-row>
            <v-col v-for="(area, index) of form.soilAreas" :key="index">
              <v-chip close @click:close="removeArea(index)">
                <v-icon left color="primary"> mdi-sprout </v-icon>
                {{ area.name }}
              </v-chip>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pt-0 pb-5">
              <span class="primary--text font-weight-bold">Superficie a tratar:
                {{ parseFloat(form.surface).toFixed(2) }} Ha</span>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>
<script>
//VUEX
import { mapState, mapMutations, mapActions } from "vuex";
// Validations
import {
  requiredValidation,
  requiredFValidation,
} from "@/helpers/validations.js";
export default {
  data: () => ({
    months: [
      { text: "1 Mes", value: "1" },
      { text: "2 Meses", value: "2" },
      { text: "3 Meses", value: "3" },
      { text: "4 Meses", value: "4" },
      { text: "5 Meses", value: "5" },
      { text: "6 Meses", value: "6" },
      { text: "7 Meses", value: "7" },
      { text: "8 Meses", value: "8" },
      { text: "9 Meses", value: "9" },
      { text: "10 Meses", value: "10" },
      { text: "11 Meses", value: "11" },
      { text: "12 Meses", value: "12" },
    ],
    crop_items: [],
    soilAreas: [],
    currentSoil: null,
    search: null,
    isLoading: false,
    organizationId: null,
    errorAreas: false,
    isEnabled: false,
    isEnabledName: false,
    isVersions: false,
    messageError: "",
    version: null,
    versions: [],
    currentVersion: null,
    versionData: [],
    form: {
      name: "",
      target: "",
      notes: "",
      cycleLength: null,
      crop: null,
      soilAreas: [],
      surface: 0.0,
      targets: [],
      crops: [],
      solubilization: null,
    },
    showGenericTarget: false,
    targets: [
      {
        text: "Control de hongos patógenos de suelo",
        value: "CSPF",
      },
      {
        text: "Solubilización de Fósforo y Potasio",
        value: "PPS",
      },
      {
        text: "Control de nematodos fitopatógenos",
        value: "CPN",
      },
    ],
    targets_avocado: [
      {
        text: "Control de hongos patógenos de suelo",
        value: "CSPF",
      },
      {
        text: "Solubilización de Fósforo y Potasio",
        value: "PPS",
      },
    ],
    currentTarget: null,
    cropSelected: null,
  }),
  computed: {
    ...mapState("areasList", ["crops"]),
    validationTargets() {
      return [() => this.form.targets.length > 0 || "Objetivos requeridos"];
    },
  },
  async mounted() {
    this.SET_APPBAR_OPTIONS({
      leftButton: "back-arrow",
      funcLeftButton: this.goBack,
      rightButton: "save",
      funcRightButton: this.saveProfitData,
    });
    let user = JSON.parse(localStorage.getItem("user"));
    if (user.role == "ORG_USER" || user.role == "ORG_USER_ADMIN") {
      this.organizationId = localStorage.getItem("organizationId");
    } else {
      this.organizationId = localStorage.getItem("clientId");
    }
    this.setCropItems();
    if (this.$route.params.profitId) {
      try {
        let response = await this.getVersionsById({
          profitId: this.$route.params.profitId,
        });
        if (response) {
          if (!response.error) {
            this.isVersions = false;
            this.isEnabled = true;
            this.form.name = response.protocol.protocolName;
            this.form.crop = response.protocol.cropName;
            this.form.crops = response.protocol.crops || [];
            this.form.solubilization = response.protocol.solubilization || null;
            for (let i = 0; i < response.protocol.profits.length; i++) {
              this.versions.push(i + 1);
            }
            this.versionData = response.protocol.profits;
            this.version = this.versions[0];
            this.changeVersion();
          } else {
            this.SET_ALERT_TYPE({
              visible: true,
              type: "error",
              text:
                "Algo salio mal al cargar rentabilización, intente de nuevo !!",
              timeout: 4000,
            });
          }
        } else {
          this.SET_ALERT_TYPE({
            visible: true,
            type: "error",
            text:
              "Algo salio mal al cargar rentabilización, intente de nuevo !!",
            timeout: 4000,
          });
        }
      } catch (e) {
        console.log(e);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: "Algo salio mal al cargar rentabilización, intente de nuevo !!",
          timeout: 4000,
        });
      }
    } else if (this.$route.params.profitVersionId) {
      try {
        let response = await this.getVersionById({
          profitId: this.$route.params.profitVersionId,
        });
        if (response) {
          if (!response.error) {
            this.isEnabled = true;
            this.isEnabledName = true;
            this.form.name = response.protocol.protocolName;
            this.form.crop = response.protocol.cropName;
            this.form.crops = response.protocol.crops || [];
             this.form.solubilization = response.protocol.solubilization || null;
          } else {
            this.SET_ALERT_TYPE({
              visible: true,
              type: "error",
              text:
                "Algo salio mal al cargar rentabilización, intente de nuevo !!",
              timeout: 4000,
            });
          }
        } else {
          this.SET_ALERT_TYPE({
            visible: true,
            type: "error",
            text:
              "Algo salio mal al cargar rentabilización, intente de nuevo !!",
            timeout: 4000,
          });
        }
      } catch (e) {
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: "Algo salio mal al cargar rentabilización, intente de nuevo !!",
          timeout: 4000,
        });
      }
    }
  },
  methods: {
    ...mapMutations(["SET_APPBAR_OPTIONS", "SET_LOADER"]),
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    ...mapActions("profit", [
      "getFieldByCrop",
      "saveProfit",
      "getVersionById",
      "saveVersionProfit",
      "getVersionsById",
      "updateProfit",
    ]),
    goBack() {
      this.$router.back();
    },
    async saveProfitData() {
      // if (this.form.soilAreas.length <= 0) {
      //   this.errorAreas = true;
      //   this.messageError = "Seleccione por lo menos una unidad agrícola";
      // } else {
      //   this.errorAreas = false;
      // }
      if (this.$refs.form.validate() && !this.errorAreas) {
        try {
          this.SET_LOADER(true);
          let request = {
            farmUnits: this.form.soilAreas,
            client: this.organizationId,
            target: this.form.target,
            targets: this.form.targets,
            totalHa: this.form.surface,
            duration: this.form.cycleLength,
            notes: this.form.notes,
            name: this.form.name,
            cropName: this.form.crop,
            crops: this.form.crops,
            solubilization: this.form.solubilization,
          };
          if (this.form.targets.length > 0) {
            request.targets = this.form.targets.map((element) => element.value);
          }
          let response = null;
          let message = "";
          if (this.$route.params.profitId) {
            //update
            request.versionId = this.$route.params.profitId;
            request._id = this.currentVersion._id;
            response = await this.updateProfit(request);
            message = "Versión actualizada!!";
          } else if (this.$route.params.profitVersionId) {
            //add version
            request.profitVersionId = this.$route.params.profitVersionId;
            response = await this.saveVersionProfit(request);
            message = "Versión añadida!!";
          } else {
            //add new profit
            response = await this.saveProfit(request);
            message = "Rentabilización creada!!";
          }

          if (response) {
            if (!response.error) {
              this.SET_ALERT_TYPE({
                visible: true,
                type: "success",
                text: message,
                timeout: 4000,
              });
              this.SET_LOADER(false);
              this.goBack();
            } else {
              this.SET_LOADER(false);
              console.log(response.message);
              this.SET_ALERT_TYPE({
                visible: true,
                type: "error",
                text:
                  "Algo salio mal al crear rentabilización, intente de nuevo !!",
                timeout: 4000,
              });
            }
          } else {
            this.SET_LOADER(false);
            this.SET_ALERT_TYPE({
              visible: true,
              type: "error",
              text:
                "Algo salio mal al crear rentabilización, intente de nuevo !!",
              timeout: 4000,
            });
          }
        } catch (e) {
          this.SET_LOADER(false);
          this.SET_ALERT_TYPE({
            visible: true,
            type: "error",
            text:
              "Algo salio mal al crear rentabilización, intente de nuevo !!",
            timeout: 4000,
          });
        }
      }
    },
    removeArea(index) {
      let item = this.form.soilAreas[index];
      this.form.surface = this.form.surface - item.ha;
      this.form.soilAreas.splice(index, 1);
    },
    removeTarget(index) {
      this.form.targets.splice(index, 1);
    },
    cleanError() {
      this.errorAreas = false;
      this.messageError = "";
    },
    setCropItems() {
      let cropsArray = Object.entries(this.crops);
      for (let crop of cropsArray) {
        this.crop_items.push({
          text: crop[1],
          value: crop[0],
        });
      }
    },
    getCrop(item) {
      let cropFpund = this.crop_items.find(element => element.value == item)
      return cropFpund ? cropFpund.text : item
    },
    removeCrop(index) {
      this.form.crops.splice(index, 1)
    },
    validation(value) {
      return requiredValidation(value);
    },
    validationF(value) {
      return requiredFValidation(value);
    },
    changeIdentificationValue() {
      if (!this.search) {
        this.currentSoil = null;
      }
    },
    cleanSearch() {
      this.currentSoil = null;
      this.search = null;
    },
    changeVersion() {
      let version = Number(this.version) - 1;

      this.currentVersion = this.versionData[version];
      this.form.target = this.currentVersion.target;
      this.form.notes = this.currentVersion.notes;
      this.form.cycleLength = this.currentVersion.cycleLength ? this.months[
        Number(this.currentVersion.cycleLength) - 1
      ].value: 0
      this.form.solubilization = this.currentVersion.solubilization || null;
      this.form.soilAreas = [];
      this.form.surface = 0;
      this.form.targets = [];
      if (
        this.currentVersion.targets
      ) {
        this.showGenericTarget = false;
        for (let item of this.currentVersion.targets) {
          let data = this.targets.find((element) => element.value == item);
          if (data) {
            this.form.targets.push(data);
          }
        }
      } else {
        this.showGenericTarget = true;
      }
      for (let item of this.currentVersion.farmUnitList) {
        this.form.surface += item.ha;
        this.form.soilAreas.push(item);
      }
    },
  },
  watch: {
    async search(value) {
      if (this.form.crops && value) {
        try {
          this.isLoading = true;
          let response = await this.getFieldByCrop({
            client: this.organizationId,
            crop: `[${this.form.crops.toString()}]`,
            data: value,
          });
          if (response) {
            if (!response.error) {
            } else {
              console.log(response.message);
            }
            this.soilAreas = response.farmUnitList;
          } else {
            console.log("ERROR");
          }
        } catch (e) {
          console.log(e);
        }
        this.isLoading = false;
      }
    },
    currentSoil(value) {
      console.log(value);
      let flag = false;

      if (value) {
        if (typeof value == "object") {
          for (let item of this.form.soilAreas) {
            if (item._id === value._id) {
              flag = true;
              break;
            }
          }
          if (!flag) {
            this.form.soilAreas.push(value);
            this.form.surface += value.ha;
          }
        }
        this.$refs["units"].reset();
        this.cleanSearch();
      }
    },
    cropSelected(value) {
      if (value) {
        if (!this.form.crops.some(element => element == value)) {
          this.form.crops.push(value);
        }
        this.$refs["crop_input"].reset();
      }
    },
    currentTarget(value) {
      let flag = false;

      if (value) {
        if (typeof value == "object") {
          for (let item of this.form.targets) {
            if (item.value === value.value) {
              flag = true;
              break;
            }
          }
          if (!flag) {
            this.form.targets.push(value);
          }
        }
        this.$refs["targets"].reset();
        this.currentTarget = null;
      }
    },
    version() {
      this.changeVersion();
    },
  },
};
</script>
